import { render, staticRenderFns } from "./DataModeVuetablePagination.vue?vue&type=template&id=070ea170&"
import script from "./DataModeVuetablePagination.vue?vue&type=script&lang=js&"
export * from "./DataModeVuetablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports